import { render, staticRenderFns } from "./FundingAssessmentsAssessors.vue?vue&type=template&id=34c5a838&"
import script from "./FundingAssessmentsAssessors.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsAssessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports